export default {"src":"/_next/static/media/maskGroup1.59e231b7.svg","height":349,"width":591,"blurWidth":0,"blurHeight":0};